import React from 'react';
import { compose } from 'redux';
import ReactGA from 'react-ga';

import { Page } from '../components';
import { Content } from '../components/Content/SuccessScreen';

ReactGA.pageview(window.location.pathname + window.location.search);

const SuccessScreen = () => (
  <Page id="main">
    <Content />
  </Page>
);

export default compose()(SuccessScreen);
